<template>
  <div
    class="loader-wrapper"
    :class="{
      stretched: stretch,
      inverse: inverse,
    }"
  >
    <div class="dot-floating">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "Loader",
  props: {
    msg: String,
    stretch: Boolean,
    inverse: Boolean,
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.loader-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 0.438rem;
  overflow: hidden;

  .dot-floating {
    position: relative;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #f8f8ff;
    color: #f8f8ff;
    animation: dotFloating 3s infinite cubic-bezier(0.15, 0.6, 0.9, 0.1);

    &::before {
      content: "";
      display: inline-block;
      position: absolute;
      top: 0;
      left: -12px;
      width: 10px;
      height: 10px;
      border-radius: 5px;
      background-color: #f8f8ff;
      color: #f8f8ff;
      animation: dotFloatingBefore 3s infinite ease-in-out;
    }

    &::after {
      content: "";
      display: inline-block;
      position: absolute;
      top: 0;
      left: -24px;
      width: 10px;
      height: 10px;
      border-radius: 5px;
      background-color: #f8f8ff;
      color: #f8f8ff;
      animation: dotFloatingAfter 3s infinite cubic-bezier(0.4, 0, 1, 1);
    }
  }

  &.stretched {
    height: 100vh;
    width: 100vw;
    position: static;
  }

  &.inverse {
    background: none;

    .dot-floating {
      background-color: black;
      color: black;

      &::before,
      &::after {
        background-color: black;
        color: black;
      }
    }
  }
}

@keyframes dotFloating {
  0% {
    left: calc(-50% - 5px);
  }
  75% {
    left: calc(50% + 105px);
  }
  100% {
    left: calc(50% + 105px);
  }
}

@keyframes dotFloatingBefore {
  0% {
    left: -50px;
  }
  50% {
    left: -12px;
  }
  75% {
    left: -50px;
  }
  100% {
    left: -50px;
  }
}

@keyframes dotFloatingAfter {
  0% {
    left: -100px;
  }
  50% {
    left: -24px;
  }
  75% {
    left: -100px;
  }
  100% {
    left: -100px;
  }
}
</style>
